import {
  delimiter,
  generateCleanFilter,
  singularListingType,
} from "../shared/util";
import { Link } from "react-router";
import LocationMap from "./location-map";
import ManageWatchedSearches from "./watch-this-search/manage-watched-searches";
import objectAssign from "object-assign";
import PlusMinus from "./controls/plus-minus";
import PriceSlider from "./controls/price-slider";
import PriceDropDown from "./controls/price-dropdown";
import PropTypes from "prop-types";
import React from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import request from "superagent";
import SaleRentalToggle from "./controls/sale-rental-toggle";
import WatchThisSearch from "./watch-this-search/watch-this-search";
import SearchBox from "./search-box/searchBox";

import "./controls/controls.scss";
import "./features/features.scss";
import "./locations/locations.scss";
import "./maps/maps.scss";

const defaults = {
  source: "all",

  minPrice: 0,
  maxPrice: 1000000000,
  bedrooms: 0,
  bathrooms: 0,
  bannerFilter: "all",
  page: 1,
  zip: null,
  searchKey: "",
  neighborhood: "",
  postalTown: "",
  listingSearch: "",
};

const doNotResetFilterKeys = ["regionUrlParts"];

class Controls extends React.Component {
  constructor(props, context) {
    super(props);
    this.router = context.router;
    this.state = {
      count: props.count || "0",
      filter: {
        regionUrlParts: props.entity.regionUrlParts,
        listingType: singularListingType(props.params.listingType), //sale or rental
        source: this.parseProps(
          props,
          "source",
          props.params.region === "global" ? "sir" : defaults.source
        ),

        minPrice: this.parseProps(props, "minPrice", defaults.minPrice), //will be updated based on query params else default value
        maxPrice: this.parseProps(props, "maxPrice", defaults.maxPrice), //will be updated based on query params else default value
        bedrooms: this.parseProps(props, "bedrooms", defaults.bedrooms),
        bathrooms: this.parseProps(props, "bathrooms", defaults.bathrooms),
        page: this.parseProps(props, "page", defaults.page),
        bannerFilter: props.bannerFilter
          ? props.bannerFilter
          : defaults.bannerFilter,
        zip: this.parseProps(props, "zip", defaults.zip),
        postalTown: this.parseProps(
          props,
          "postalTown",
          props.params.postalTown
            ? props.params.postalTown
            : defaults.postalTown
        ),
        neighborhood: this.parseProps(
          props,
          "neighborhood",
          props.params.neighborhood
            ? props.params.neighborhood
            : defaults.neighborhood
        ),
      },
      showLocations: false,
      showFeatures: false,
      listingType: props.params.listingType,
      features: [],
      showMobileFilters: false,
      searchHeader: this.searchHeader(
        props.region.searchHeader,
        props.params.listingType
      ),
      searchTerm: "",
    };
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  searchHeader = (regionValue, listingType) => {
    //HACK:
    //TODO: the region object does not get updated when type changes; maybe it makes sense to make a server request for the page (reload)?
    if (listingType === "rentals") {
      return regionValue.replace("Sale", "Rent");
    } else {
      return regionValue.replace("Rent", "Sale");
    }
  };

  parsePosition = (props, field) => {
    if (props.location && props.location.query && props.location.query[field]) {
      const query = props.location.query;
      return query[field];
    } else {
      return "";
    }
  };

  parseProps = (props, field, defaultValue) => {
    if (props.location && props.location.query && props.location.query[field]) {
      let queryItem = props.location.query[field];
      if (queryItem.indexOf(delimiter) !== -1) {
        queryItem = queryItem.split(delimiter).map(function (item) {
          return !isNaN(item) ? parseInt(item, 10) : item;
        });
      } else if (field === "zip") {
        return queryItem; //NOTE: don't parseInt
      } else if (!isNaN(queryItem)) {
        queryItem = parseInt(queryItem, 10); //prices will come here
      }
      if (defaultValue instanceof Array) {
        return [].concat(queryItem);
      }
      return queryItem;
    } else {
      return defaultValue instanceof Array
        ? defaultValue.slice()
        : defaultValue;
    }
  };

  updateUrl = (filter) => {
    const pathname = this.props.location.pathname;
    this.router.replace({ pathname: pathname, query: filter, state: null });
  };

  updateCount = (filter) => {
    //removed idx for nyc rentals
    if (
      filter.source === "all" &&
      filter.listingType === "rental" &&
      filter.regionUrlParts.includes("nyc")
    ) {
      filter.source = "sir";
    }
    this.countRequest = request
      .post("/api/listings/count")
      .set("Content-Type", "application/json")
      .send(filter)
      .end((error, response) => {
        this.setState(response.body);
      });
  };

  addExclusionsToFilter = (filter) => {
    let newFilter = {
      ...filter,
      idxExclusions: this.props.entity.siteOptions.idxExclusions,
    };
    if (!this.props.entity.supportsMls) {
      newFilter.source = "sir";
    }
    return newFilter;
  };

  componentDidMount() {
    this.updateCountAndResults();
    let region;
    if (this.props.params && this.props.params.region) {
      region = this.props.params.region;
    } else {
      region = "global";
    }
  }

  addSubtractFilter = (field, integer) => {
    let filter = this.state.filter;
    const newValue = filter[field] + integer;
    //max value 5
    if (newValue >= 0 && newValue < 6) {
      filter[field] = newValue;
      this.setState({ filter: filter }, this.updateCountAndResults);
    }
  };

  handlePriceChange = (min, max) => {
    let filter = this.state.filter;
    if (min !== filter.minPrice) {
      filter.minPrice = min;
    }
    if (max !== filter.maxPrice) {
      filter.maxPrice = max;
    }
    filter.page = defaults.page; //when price changed page defaulted to 1
    this.setState({ filter: filter }, this.updateCountAndResults);
  };

  handleLocationChange = (value, isSearch) => {
    let filter = this.state.filter;
    const searchUrl = "/api/listings/search";
    delete filter.neighborhood;
    delete filter.postalTown;
    if (isSearch) {
      filter.searchKey = value;
    } else {
      delete filter.searchKey;
      filter[value.key] = value["value"];
      this.props.clearResults();
    }
    this.setState(
      { filter: filter },
      this.updateCountAndResults(isSearch ? searchUrl : null, filter)
    );
  };

  debounce = (callback, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => callback(...args), delay);
    };
  };

  debouncedSearch = this.debounce(
    (value, isSearch) => this.handleLocationChange(value, isSearch),
    500
  );

  handleListingTypeChange = (type, e) => {
    let filter = this.state.filter;
    filter.listingType = singularListingType(type);
    filter.minPrice = defaults.minPrice;
    filter.maxPrice = defaults.maxPrice;
    this.setState(
      {
        listingType: type,
        filter: filter,
        searchHeader: this.searchHeader(this.state.searchHeader, type),
      },
      this.updateCountAndResults
    );
  };

  updateCountAndResults = (url, updatedFilter) => {
    let filter = this.addExclusionsToFilter(
      url ? updatedFilter : this.state.filter
    );
    if (!url) {
      delete filter.searchKey;
      this.updateCount(filter);
    }
    if (this.props.mergeFilter) {
      this.props.mergeFilter(filter, url);
      this.updateUrl(generateCleanFilter(filter, defaults)); // HAL later
    }
  };

  resetFilter = (event) => {
    if (event) {
      event.preventDefault();
    }
    if (this.props.resetBannerFilter) {
      this.props.resetBannerFilter();
    }
    let filter = this.state.filter;
    filter = objectAssign(filter, defaults);
    Object.keys(filter)
      .filter((key) => doNotResetFilterKeys.indexOf(key) === -1)
      .forEach(function (key) {
        if (filter[key] instanceof Array && filter[key].length) {
          filter[key] = [];
        }
      });
    this.setState(
      {
        filter: filter,
        showFeatures: false,
        showLocations: false,
      },
      this.updateCountAndResults()
    );
  };

  toggleMobileFilters = (event) => {
    event.preventDefault();
    this.setState({
      showMobileFilters: !this.state.showMobileFilters,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.bannerFilter !== this.props.bannerFilter) {
      let filter = this.state.filter;
      filter.bannerFilter = nextProps.bannerFilter;
      this.setState({ filter: filter }, this.updateCountAndResults);
    }
  }

  componentWillUnmount() {
    if (this.countRequest) {
      this.countRequest.abort();
    }
  }

  clearSearch = () => {
    this.resetFilter();
    this.props.clearResults();
  };

  render() {
    let viewResultsLink = null;
    let onLanding = !this.props.mergeFilter;

    if (onLanding) {
      viewResultsLink = (
        <Link
          id="search-input-view-button"
          to={{
            pathname:
              "/" +
              this.props.params.region +
              "/" +
              (this.state.filter.listingType === "sale" ? "sales" : "rentals"),
            query: generateCleanFilter(this.state.filter, defaults),
          }}
          className="secondary-button"
        >
          View results
        </Link>
      );
    }

    return (
      <div
        className={
          "search-control-bar" +
          (this.state.showMobileFilters ? "" : " filter-toggle-off")
        }
      >
        <div className="container">
          <div className="row title-row">
            <div className="col-md-10 col-sm-10 col-xs-11 col-mirco-16">
              {/* <h1>{this.state.searchHeader}</h1> */}
            </div>

            <div className="col-md-6 col-sm-6 col-xs-5 col-mirco-16 filter-toggle">
              <SaleRentalToggle
                supportsRentals={this.props.region.supportsRentals}
                onLanding={onLanding}
                currentType={this.state.filter.listingType}
                handleToggle={this.handleListingTypeChange}
                baseRoute={
                  this.props.params.region === "global"
                    ? ""
                    : `/${this.props.params.region}`
                }
                cleanFilter={generateCleanFilter(this.state.filter, defaults)}
              />
            </div>
            <div className="spacer-3 visible-xxs-block ">&nbsp;</div>
          </div>

          <div id="search-inputs" role="region" aria-label="Filters">
            <div
              className={
                this.state.showMobileFilters
                  ? "auto-complete-search search-input "
                  : "auto-complete-search search-input hidden-xxs"
              }
            >
              <SearchBox
                debouncedSearch={this.debouncedSearch}
                results={this.props.searchResults}
                handleLocationChange={this.handleLocationChange}
                clearResults={this.clearSearch}
              />
            </div>

            <PriceSlider
              listingType={this.state.filter.listingType}
              min={this.state.filter.minPrice}
              max={this.state.filter.maxPrice}
              handleChange={this.handlePriceChange}
              region={this.props.region} //check
            />

            <PriceDropDown
              listingType={this.state.filter.listingType}
              min={this.state.filter.minPrice}
              max={this.state.filter.maxPrice}
              handleChange={this.handlePriceChange}
              region={this.props.region}
              className="filter-toggle"
            />

            <PlusMinus
              header="Bedrooms"
              handleChange={this.addSubtractFilter}
              field="bedrooms"
              value={this.state.filter.bedrooms}
              label="beds or more"
              singularLabel="bed or more"
              zeroLabel="show all"
              className="filter-toggle"
            />

            <PlusMinus
              header="Bathrooms"
              handleChange={this.addSubtractFilter}
              field="bathrooms"
              value={this.state.filter.bathrooms}
              label="baths or more"
              singularLabel="bath or more"
              zeroLabel="show all"
              className="filter-toggle"
            />

            <div className="search-input large listings-selector-input filter-mobile">
              <a
                href="#"
                className="filter-view-button filter-button"
                onClick={this.toggleMobileFilters}
              >
                {(this.state.showMobileFilters ? "Hide" : "Show") + " Filters"}
              </a>
              <h2>Listings found</h2>
              <button
                type="button"
                href="#"
                className="reset-button filter-button"
                onClick={this.resetFilter}
              >
                Reset
              </button>
              <div className="lower-sec">
                <div className="listing-total-display">{this.state.count}</div>
                {viewResultsLink}
                <div className="clearfix">&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
        <WatchThisSearch
          search={objectAssign(
            {},
            this.addExclusionsToFilter(this.state.filter),
            { page: 1 }
          )}
          route={this.props.route}
        />
        <ManageWatchedSearches />
      </div>
    );
  }
}

Controls.propTypes = {
  config: PropTypes.object.isRequired,
  bannerFilter: PropTypes.string.isRequired,
  mergeFilter: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  sourceLocations: PropTypes.array,
  params: PropTypes.object.isRequired,
  region: PropTypes.object.isRequired,
  resetBannerFilter: PropTypes.func.isRequired,
  route: PropTypes.object.isRequired,
  searchResults: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  clearResults: PropTypes.func.isRequired,
};

export default Controls;



// WEBPACK FOOTER //
// ./src/components/search/controls.jsx